var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 1.5H13.125C13.3125 1.5 13.5 1.6875 13.5 1.875V5.625C13.5 5.83594 13.3125 6 13.125 6C12.9141 6 12.75 5.83594 12.75 5.625V2.78906L7.00781 8.53125C6.86719 8.67188 6.60938 8.67188 6.46875 8.53125C6.32812 8.39062 6.32812 8.13281 6.46875 7.99219L12.2109 2.25H9.375C9.16406 2.25 9 2.08594 9 1.875C9 1.6875 9.16406 1.5 9.375 1.5ZM3 2.25H6.375C6.5625 2.25 6.75 2.4375 6.75 2.625C6.75 2.83594 6.5625 3 6.375 3H3C2.57812 3 2.25 3.35156 2.25 3.75V12C2.25 12.4219 2.57812 12.75 3 12.75H11.25C11.6484 12.75 12 12.4219 12 12V8.625C12 8.4375 12.1641 8.25 12.375 8.25C12.5625 8.25 12.75 8.4375 12.75 8.625V12C12.75 12.8438 12.0703 13.5 11.25 13.5H3C2.15625 13.5 1.5 12.8438 1.5 12V3.75C1.5 2.92969 2.15625 2.25 3 2.25Z",
    fill: "#0D2EA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external-link.e50b5a789bf87ae0969a1a81a9c5b036.svg";
export { ForwardRef as ReactComponent };